import angular from 'angular';
import informationComponent from './information.component';
import productLabelDownload from './product-label-download/product-label-download.module';

export default angular.module('components.app.product.information', [
  productLabelDownload
])
  .component('information', informationComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/information/information.module.js